module.exports = __webpack_public_path__ + "static/media/okra-curry.02cddcf5.jpg";